import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useLevel1SectionData } from '../../hooks/useLevel1Section';

const skipKeys = ['under_hood_3_point_body_lines_paint_check', 'frame_fit_finish_under_hood'];

export const UnderHood = () => {
  const { subSections, images } = useLevel1SectionData('under_hood');

  return (
    <Level2Wrapper flex="1 1 100%" label="Under Hood">
      <ImageList label="Under Hood Pictures" images={images} />
      {Object.values(subSections).map(section => {
        if (!section.grade || skipKeys.includes(section.name)) return null;
        return <GenericSubSection key={section.id} section={section} />;
      })}
    </Level2Wrapper>
  );
};
